import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsEmpty, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { StoreExposeGroup, StoreModeEnum, StorePOSProviderEnum, StoreSpecificTypeEnum, StoreStateEnum, StoreTargetEnum, } from '../interface';
import { SquareDataDto } from './SquareDataDto';
import { StoreContactInfoDto } from './StoreContactInfoDto';
import { StoreCountryDto } from './StoreCountryDto';
import { StoreDeliveryDto } from './StoreDeliveryDto';
import { StoreFeaturesFlagsDto } from './StoreFeaturesFlagsDto';
import { StoreGeoLocationDto } from './StoreGeoLocationDto';
import { StoreMailerDto } from './StoreMailerDto';
import { StoreManagerContactInfoDto } from './StoreManagerContactInfoDto';
import { StoreOrderDto } from './StoreOrderDto';
import { StoreOrderValidationDto } from './StoreOrderValidationDto';
import { StorePaymentDto } from './StorePaymentDto';
import { StorePickupDto } from './StorePickupDto';
import { StoreScheduleDto } from './StoreScheduleDto';
let StoreDto = class StoreDto {
};
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL] }),
    __metadata("design:type", String)
], StoreDto.prototype, "_id", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '9d3f8f9b-881a-49a7-a79e-ce53399976f7' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    IsEmpty({ always: true }),
    __metadata("design:type", String)
], StoreDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '84fbef05-41c8-42d9-b4c7-76c7e9b4588f' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    IsEmpty({ always: true }),
    __metadata("design:type", String)
], StoreDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '47bbd89f-e221-41af-bbc8-7957d491f0eb' }),
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.BASE_PATCH,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.PATCH,
        ],
    }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.BASE_PATCH] }),
    __metadata("design:type", String)
], StoreDto.prototype, "defaultStoreId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'STORE_FROM-SOMEWHERE' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    IsString({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], StoreDto.prototype, "alias", void 0);
__decorate([
    ApiProperty({ type: () => String, minLength: 3, maxLength: 50, example: 'Merchant GoParrot' }),
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.PATCH,
            StoreExposeGroup.BASE_PATCH,
        ],
    }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    __metadata("design:type", String)
], StoreDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ type: () => String, minLength: 3, maxLength: 250, example: 'Merchant GoParrot Description' }),
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.PATCH,
            StoreExposeGroup.BASE_PATCH,
        ],
    }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    __metadata("design:type", String)
], StoreDto.prototype, "subtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], StoreDto.prototype, "shortName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], StoreDto.prototype, "name", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    IsEmpty({ always: true }),
    __metadata("design:type", String)
], StoreDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ enum: StoreSpecificTypeEnum, default: StoreSpecificTypeEnum.REGULAR }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.PATCH] }),
    IsUndefinable({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsEnum(StoreSpecificTypeEnum, { always: true }),
    __metadata("design:type", String)
], StoreDto.prototype, "specificType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.PATCH] }),
    IsUndefinable({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], StoreDto.prototype, "specificCustomType", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    __metadata("design:type", String)
], StoreDto.prototype, "createdAt", void 0);
__decorate([
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    __metadata("design:type", String)
], StoreDto.prototype, "updatedAt", void 0);
__decorate([
    ApiProperty({ type: () => StoreGeoLocationDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreGeoLocationDto),
    __metadata("design:type", StoreGeoLocationDto)
], StoreDto.prototype, "location", void 0);
__decorate([
    ApiProperty({ type: () => StoreContactInfoDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.CREATE] }),
    ValidateNested({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreContactInfoDto),
    __metadata("design:type", StoreContactInfoDto)
], StoreDto.prototype, "contactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreManagerContactInfoDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.CREATE] }),
    Type(() => StoreManagerContactInfoDto),
    __metadata("design:type", StoreManagerContactInfoDto)
], StoreDto.prototype, "managerContactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreCountryDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreCountryDto),
    __metadata("design:type", StoreCountryDto)
], StoreDto.prototype, "country", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreDeliveryDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreDeliveryDto),
    __metadata("design:type", StoreDeliveryDto)
], StoreDto.prototype, "delivery", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreFeaturesFlagsDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreFeaturesFlagsDto),
    __metadata("design:type", StoreFeaturesFlagsDto)
], StoreDto.prototype, "featuresFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], StoreDto.prototype, "shortTermFeatureFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreMailerDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreMailerDto),
    __metadata("design:type", StoreMailerDto)
], StoreDto.prototype, "mailer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreOrderDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreOrderDto),
    __metadata("design:type", StoreOrderDto)
], StoreDto.prototype, "order", void 0);
__decorate([
    ApiProperty({ type: () => StorePaymentDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => StorePaymentDto),
    __metadata("design:type", StorePaymentDto)
], StoreDto.prototype, "payment", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StorePickupDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StorePickupDto),
    __metadata("design:type", StorePickupDto)
], StoreDto.prototype, "pickup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreScheduleDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreScheduleDto),
    __metadata("design:type", StoreScheduleDto)
], StoreDto.prototype, "schedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], StoreDto.prototype, "diningOptionsConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: () => StoreOrderValidationDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => StoreOrderValidationDto),
    __metadata("design:type", StoreOrderValidationDto)
], StoreDto.prototype, "orderValidation", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreTargetEnum }),
    Expose({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsEnum(StoreTargetEnum, {
        groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], StoreDto.prototype, "targetType", void 0);
__decorate([
    ApiProperty({ enum: StoreStateEnum, default: StoreStateEnum.ACTIVE }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], StoreDto.prototype, "state", void 0);
__decorate([
    ApiProperty({ enum: StoreModeEnum, default: StoreModeEnum.REAL }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], StoreDto.prototype, "mode", void 0);
__decorate([
    ApiPropertyOptional({ enum: StorePOSProviderEnum }),
    Expose({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL] }),
    IsEnum(StorePOSProviderEnum, {
        groups: [StoreExposeGroup.CREATE],
        message: 'Choose a POS system',
    }),
    IsDefined({ groups: [StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], StoreDto.prototype, "posProvider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsBoolean({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    __metadata("design:type", Boolean)
], StoreDto.prototype, "isImported", void 0);
__decorate([
    ApiPropertyOptional({ type: () => SquareDataDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    Type(() => SquareDataDto),
    __metadata("design:type", SquareDataDto)
], StoreDto.prototype, "squareData", void 0);
StoreDto = __decorate([
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.PATCH,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.BASE_PATCH,
        ],
    })
], StoreDto);
export { StoreDto };
//# sourceMappingURL=StoreDto.js.map